import { render } from "./almost_done.vue?vue&type=template&id=78455b5c&lang=pug"
import script from "./almost_done.vue?vue&type=script&lang=js"
export * from "./almost_done.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__